import { OrderDocumentType, OrderReturnStatus, OrderType } from '../../../../../clients/quipli-service/order/order';
import { ProductItemState } from '../../hooks/use-product-item-data';
import { StatusBadge } from '../../../../../components/status-badge/status-badge';

export interface ProductItemStatusBadgeProps extends Pick<ProductItemState, 'type' | 'returnStatus' | 'isNewProduct'> {
  orderDocumentType: OrderDocumentType;
}

export const ProductItemStatusBadge = ({
  type,
  returnStatus,
  isNewProduct,
  orderDocumentType,
}: ProductItemStatusBadgeProps) => {
  if (isNewProduct || orderDocumentType !== 'Order') return null;

  let label;

  if (type === OrderType.Rental) {
    switch (returnStatus) {
      case OrderReturnStatus.Complete:
        label = 'Returned';
        break;
      case OrderReturnStatus.OffRent:
        label = 'Off Rent';
        break;
      case OrderReturnStatus.OnRent:
        label = 'On Rent';
        break;
      default:
        label = 'Not Started';
    }
  } else {
    label = 'Sale';
  }

  return (
    <div className="w-fit p-1">
      <StatusBadge label={label} type="dark-grey" />
    </div>
  );
};
